import ApiRoutes from "../../../constants/api-routes";
import { hneAdsApi } from "../../../service";

export const adsAuthentication = async (body) =>
  hneAdsApi.post(`${ApiRoutes.ADS_SIGN_IN}`, body);

export const getExistingByUserName = async (body) =>
  hneAdsApi.post(`${ApiRoutes.EXISTING_USERNAME}`, body);

export const updateCompanyUserName = async (body, company_Id) =>
  hneAdsApi.put(`${ApiRoutes.UPDATE_USERNAME}/${company_Id}`, body);
